import type {PropertyDefinitionBase} from '@github-ui/custom-properties-types'
import {Link} from '@github-ui/react-core/link'
import {Breadcrumbs} from '@primer/react'
import type {ReactNode} from 'react'

import {PropertyPageHeader} from './PropertyPageHeader'

type Props = {
  definition?: PropertyDefinitionBase | null
  definitionsListPath: string
  actions?: ReactNode
  className?: string
}

export function DefinitionDetailsHeader({definition, definitionsListPath, actions, className}: Props) {
  return (
    <div className={className}>
      <Breadcrumbs className="mb-2">
        <Breadcrumbs.Item as={Link} to={definitionsListPath}>
          Custom properties
        </Breadcrumbs.Item>
        <Breadcrumbs.Item selected>{definition?.propertyName || 'New property'}</Breadcrumbs.Item>
      </Breadcrumbs>
      <PropertyPageHeader title={<div>{definition?.propertyName || 'New property'}</div>} actions={actions} />
    </div>
  )
}

try{ DefinitionDetailsHeader.displayName ||= 'DefinitionDetailsHeader' } catch {}